module.exports = new __parcel__URL__("level_3_tab_inactive.f18a1861.png").toString();